import { createResourceStore } from '@next-qr/lib-ui/store';
import { conversationApi } from './api';

export const useConversationStore = createResourceStore(conversationApi);
